import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./output.css";
import useAuthCheck from "./hooks/useAuthCheck";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";
import Login from "./pages/student/Login";
import Register from "./pages/student/Register";
import Layout from "./pages/student/Layout";
import CoursePlayer from "./pages/student/CoursePlayer";
import StudentQuizzes from "./components/student/quiz/Quizzes";
import Leaderboard from "./components/student/leaderboard/Leaderboard";
import AdminLogin from "./pages/admin/AdminLogin";
import Dashboard from "./pages/admin/Dashboard";
import Assignments from "./components/admin/assignments/Assignments";
import AdminQuizzes from "./components/admin/quizzes/Quizzes";
import AssignmentMarks from "./components/admin/assignmentMarks/AssignmentMarks";
import Videos from "./components/admin/videos/Videos";
import EditVideo from "./components/admin/videos/edit/EditVideo";
import AddVideo from "./components/admin/videos/add/AddVideo";
import AddAssignment from "./components/admin/assignments/add/AddAssignment";
import EditAssignment from "./components/admin/assignments/edit/EditAssignment";
import AddQuiz from "./components/admin/quizzes/add/AddQuiz";
import EditQuiz from "./components/admin/quizzes/edit/EditQuiz";

function App() {
	const { authChecked, userRole } = useAuthCheck() || {};

	return !authChecked ? (
		<div>Authentication checking...</div>
	) : (
		<BrowserRouter>
			<Routes>
				<Route
					path="/"
					element={
						<PublicRoute redirectOnFailure="/course-videos">
							<Login />
						</PublicRoute>
					}
				/>
				<Route
					path="/admin"
					element={
						<PublicRoute redirectOnFailure="/admin/dashboard">
							<AdminLogin />
						</PublicRoute>
					}
				/>
				{userRole === "admin" ? (
					/**
					 * Admin routes
					 */
					<Route path="/" element={<Layout />}>
						<Route
							path="/admin/dashboard"
							element={
								<PrivateRoute redirectOnFailure="/admin">
									<Dashboard />
								</PrivateRoute>
							}
						/>
                        <Route
							path="/admin/videos"
							element={
								<PrivateRoute redirectOnFailure="/admin">
									<Videos />
								</PrivateRoute>
							}
						/>
						<Route
							path="/admin/videos/add"
							element={
								<PrivateRoute redirectOnFailure="/admin">
									<AddVideo />
								</PrivateRoute>
							}
						/>
						<Route
							path="/admin/videos/edit/:videoId"
							element={
								<PrivateRoute redirectOnFailure="/admin">
									<EditVideo />
								</PrivateRoute>
							}
						/>
						<Route
							path="/admin/assignments"
							element={
								<PrivateRoute redirectOnFailure="/admin">
									<Assignments />
								</PrivateRoute>
							}
						/>
						<Route
							path="/admin/assignments/add"
							element={
								<PrivateRoute redirectOnFailure="/admin">
									<AddAssignment />
								</PrivateRoute>
							}
						/>
						<Route
							path="/admin/assignments/edit/:assignmentId"
							element={
								<PrivateRoute redirectOnFailure="/admin">
									<EditAssignment />
								</PrivateRoute>
							}
						/>
						<Route
							path="/admin/quizzes"
							element={
								<PrivateRoute redirectOnFailure="/admin">
									<AdminQuizzes />
								</PrivateRoute>
							}
						/>
						<Route
							path="/admin/quizzes/add"
							element={
								<PrivateRoute redirectOnFailure="/admin">
									<AddQuiz />
								</PrivateRoute>
							}
						/>
						<Route
							path="/admin/quizzes/edit/:quizId"
							element={
								<PrivateRoute redirectOnFailure="/admin">
									<EditQuiz />
								</PrivateRoute>
							}
						/>
						<Route
							path="/admin/assignment-marks"
							element={
								<PrivateRoute redirectOnFailure="/admin">
									<AssignmentMarks />
								</PrivateRoute>
							}
						/>
					</Route>
				) : (
					/**
					 * Student routes
					 */
					<>
						<Route
							path="/register"
							element={
								<PublicRoute redirectOnFailure="/course-videos">
									<Register />
								</PublicRoute>
							}
						/>
						<Route path="/" element={<Layout />}>
							<Route
								path="/course-videos"
								element={
									<PrivateRoute redirectOnFailure="/">
										<CoursePlayer />
									</PrivateRoute>
								}
							/>
							<Route
								path="/course-videos/:videoId"
								element={
									<PrivateRoute redirectOnFailure="/">
										<CoursePlayer />
									</PrivateRoute>
								}
							/>
							<Route
								path="/quizzes/:videoId"
								element={
									<PrivateRoute redirectOnFailure="/">
										<StudentQuizzes />
									</PrivateRoute>
								}
							/>
							<Route
								path="/leaderboard"
								element={
									<PrivateRoute redirectOnFailure="/">
										<Leaderboard />
									</PrivateRoute>
								}
							/>
						</Route>
					</>
				)}
			</Routes>
		</BrowserRouter>
	);
}

export default App;
